import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import Select from 'react-select';

const RegionField = ({ regionSelectOptions }) => {
  return (
    <Field name="court_code" parse={values => values.map(({ value }) => value)}>
      {({ input }) => (
        <Fragment>
          <label>Region</label>
          <Select {...input} multi options={regionSelectOptions} className="form-select" />
        </Fragment>
      )}
    </Field>
  );
};

RegionField.propTypes = {
  regionSelectOptions: PropTypes.array.isRequired,
};

export default RegionField;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/fields/RegionField.jsx